import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { TruckIcon, LogIn, Eye, EyeOff } from 'lucide-react';
import api from '../lib/api';

const DistribuidorLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Complete todos los campos');
    setLoading(true);
    try {
      const res = await api.post('/distribuidor/login', { email, password });
      localStorage.setItem('dist_token', res.data.access_token);
      localStorage.setItem('distribuidor', JSON.stringify(res.data.distribuidor));
      toast.success(`Bienvenido, ${res.data.distribuidor.nombre}`);
      navigate('/distribuidor');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error de autenticacion');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-950 to-purple-950 flex items-center justify-center p-4" data-testid="dist-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-indigo-600/30 border-2 border-indigo-400/30 flex items-center justify-center mb-4">
            <TruckIcon className="h-8 w-8 text-indigo-300" />
          </div>
          <h1 className="text-2xl font-black text-white">Portal Distribuidor</h1>
          <p className="text-indigo-300/70 text-sm mt-1">Acceda a sus furgones y facturas</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 space-y-4">
          <div>
            <Label className="text-indigo-200 font-semibold text-sm">Email</Label>
            <Input data-testid="dist-login-email" type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="correo@empresa.com" className="h-12 mt-1 bg-white/10 border-white/20 text-white placeholder:text-white/30" />
          </div>
          <div>
            <Label className="text-indigo-200 font-semibold text-sm">Contrasena</Label>
            <div className="relative mt-1">
              <Input data-testid="dist-login-password" type={showPass ? 'text' : 'password'} value={password}
                onChange={e => setPassword(e.target.value)} placeholder="********"
                className="h-12 bg-white/10 border-white/20 text-white placeholder:text-white/30 pr-12" />
              <button type="button" onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70">
                {showPass ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <Button data-testid="dist-login-submit" type="submit" disabled={loading}
            className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-base gap-2">
            {loading ? 'Verificando...' : <><LogIn className="h-5 w-5" /> Iniciar Sesion</>}
          </Button>
        </form>

        <p className="text-center text-white/30 text-xs mt-6">
          Contacte al administrador si no tiene acceso
        </p>
      </div>
    </div>
  );
};

export default DistribuidorLogin;
